import React, { Component } from 'react'
import './App.css'
import Grid from "./components/Grid";
import NodeLegend from "./components/NodeLegend";
import Figure from "./components/Figure";

type Props = {
}

type State = {
  spoilersVisible: boolean,
}

class App extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      spoilersVisible: false,
    }
  }

  // noinspection JSMethodCanBeStatic
  renderMainPost() {
    let spoilerOrNot;
    let showSpoilerButton;
    if (!this.state.spoilersVisible) {
      spoilerOrNot = "spoiler";
      // showSpoilerButton = <WidgetButton highlighted={false} onClick={() => { this.setState({criticalThresholdVisible: true}); } } >Show spoilers</WidgetButton>
    } else {
      spoilerOrNot = "spoiler-revealed";
      // showSpoilerButton = <WidgetButton highlighted={false} onClick={() => { this.setState({criticalThresholdVisible: false}); } } >Hide spoilers</WidgetButton>
    }
    showSpoilerButton = <label><span style={{cursor: "pointer"}}><input type="checkbox" value={this.state.spoilersVisible} onChange={(e) => { this.setState({spoilersVisible: e.target.checked}); }}/> Show spoilers</span></label>;


    let exposed_you = <code className="code-exposed">you</code>;

    let susceptible = <code className="code-susceptible">Susceptible</code>;
    let infected = <code className="code-infectious">Infected</code>;
    let recovered = <code className="code-removed">Recovered</code>;
    let dead = <code className="code-dead">Dead</code>;
    let selfQuarantined = <code className="code-quarantined">Self-quarantined</code>;

    // noinspection HtmlRequiredAltAttribute
    return (
      <div className="post-content">
        <div>
          <h1>Simulation einer Epidemie</h1>
          <h5 className="author">von Lukas Wachter in Anlehnung an Kevin Simler<br/>April 2020</h5>
        </div>
        <div>
          Die folgenden Simulationen sollen schrittweise dazu beitragen, das Verständnis über die Ausbreitung von Viren sowie den Einfluss die Verbreitung hemmender Maßnahmen zu stärken. Die hier dargestellten Simulationen basieren auf einem vereinfachten Modell, das das Prinzip der Ausbreitung eines Virus verdeutlicht. <strong>Sie erheben keinen Anspruch darauf die Ausbreitung eines konkreten Virus (z.B. SARS-CoV-2) präzise zu modellieren</strong>, sondern zeigen allgemeine Verhaltensweisen von Viren in Reaktion auf bestimmte Verhaltensweisen von uns Menschen.
        </div>
        <div>
          Das besondere Augenmerk liegt hierbei darauf, dass die verschiedenen Modelle auf spielerische Art und Weise erkundet werden können: Unter vielen der Simulationen finden Sie Schieberegler u.Ä., um die sogenannten Parameter des Modells einzustellen. Diese Parameter beeinflussen direkt oder indirekt die Simulation. Beispiele für solche Parameter wären zum Beispiel die Sterblichkeitsrate, die Einschränkung von Reisen zwischen verschiedenen Ländern oder die Reduzierung der sozialen Kontakte.
        </div> 
        <div>
          Ziel dieses Beitrags ist, dass Sie eine bessere Intuition darüber erlangen, warum zur Zeit der Corona-Pandemie bestimmte Maßnahmen ergriffen wurden und werden und wie diese dazu beitragen, die Ausbreitung des Virus zu verlangsamen.  
        </div>
        <div>
        Im Laufe der Website sind immer wieder Angebote zum Selbsttest eingebaut. Dabei handelt es sich z.B. um Multiple-Choice-Fragen, Fill-The-Blanks-Aufgaben o.Ä., die den Inhalt bis dato wiederholen. Die Ergebnisse dieser Aufgaben werden nur lokal gespeichert und sind nicht notwendigerweise zu bearbeiten. Sie können beispielsweise als Selbstlernkurs in Kombination mit den verlinkten Youtube-Videos genutzt werden. Eine Aufgabe kann beispielsweise so aussehen:
        </div>
        <div><iframe src="https://infolab.cs.uni-saarland.de/wp-admin/admin-ajax.php?action=h5p_embed&id=3" width="936" height="255" frameborder="0" allowfullscreen="allowfullscreen"></iframe><script src="https://infolab.cs.uni-saarland.de/wp-content/plugins/h5p/h5p-php-library/js/h5p-resizer.js" charset="UTF-8"></script></div>
        <div>
          <h3>Ein einfaches Raster von Menschen</h3>
        </div>
        <div>
          Betrachten wir zunächst einmal eine einfache Bevölkerung aus 9x9 Menschen, die der Übersichtlichkeit wegen in einem entsprechenden Raster angeordnet werden. Eine Person - ja korrekt, das einzelne rote Quadrat in der Mitte - hat sich mit einer Krankheit angesteckt, sie wird als <strong>infected</strong>, zu deutsch: infiziert, bezeichnet. Alle anderen Personen, repräsentiert durch die übrigen Quadrate sind zu diesem Zeitpunkt gesund in dem Sinne, dass Sie den Erreger nicht in sich tragen, stehen jedoch jederzeit der Gefahr gegenüber, infiziert zu werden. Sie werden als <strong>susceptible</strong> (anfällig) bezeichnet. 
        </div>
        <Figure>
          <Grid daysIncubating={0}
                daysSymptomatic={1}
                gridRows={9}
                gridCols={9}
                nodeSize={30}
                nug={1}
                randomSeed={100}
                personHours={4}
                showPlaybackControls={false}
                speed={0.4}
                transmissionProbability={1}
                travelRadius={1}
          />
        </Figure>
        <div>
          Zur Zeit ist diese Bevölkerung recht uninteressant und statisch. Es fehlt ein kritischer Faktor: Zeit.
        </div>
        <div>
          <h3>Die Zeit kommt mit ins Spiel</h3>
        </div>
        <div>
          Über die 3 Buttons unter der Grafik können im Folgenden die Simulationen über mehrere Tage simuliert werden. Jeder ausgeführte Schritt entspricht dabei einem Tag. Die Buttons haben die folgende Funktion:
        </div>
        <div>  
          <ul>
            <li>Step: Führt einen Schritt (also einen Tag) der Simulation durch. </li>
            <li>Play: Führt die Simulation für mehrere Tage hintereinander aus.</li>
            <li>Reset: Setzt die Simulation zurück auf "Tag 0", an dem es den ersten und einzigen Infizierten gab. </li>
          </ul>
        </div>
        <Figure>
          <Grid daysIncubating={0}
                daysSymptomatic={10000000000}
                gridRows={9}
                gridCols={9}
                nodeSize={30}
                nug={1}
                randomSeed={100}
                personHours={4}
                showInteractions={false}
                speed={0.4}
                transmissionProbability={1}
                travelRadius={1}
          />
        </Figure>
        <div>
        <iframe src="https://infolab.cs.uni-saarland.de/wp-admin/admin-ajax.php?action=h5p_embed&id=5" width="936" height="204" frameborder="0" allowfullscreen="allowfullscreen"></iframe><script src="https://infolab.cs.uni-saarland.de/wp-content/plugins/h5p/h5p-php-library/js/h5p-resizer.js" charset="UTF-8"></script>
        </div>
        <div>
          Aber entspricht das der Realität? Es gibt doch sicher auch einige Menschen, die sich von der Krankheit erholen.
        </div>
        <div>
          <h3>Genesung von Patienten</h3>
        </div>
        <div>
          Angenommen der sich ausbreitende Virus verursacht eine kurzfristige Krankheit: Nach 2 Tagen sind die Patienten wieder genesen. Ein genesener Patient wird nun als <strong>recovered</strong> bezeichnet und durch einen grauen Punkt dargestellt. Die Grafik zeigt, wie sich das Modell unter den bisherigen Angaben verhält.
        </div>
        <Figure>
          <Grid daysIncubating={0}
                daysSymptomatic={2}
                gridRows={9}
                gridCols={9}
                nodeSize={30}
                nug={1}
                randomSeed={100}
                personHours={4}
                showInteractions={false}
                speed={0.4}
                transmissionProbability={1}
                travelRadius={1}
          />
        </Figure>
        <div>
          Diese 3 Klassen sind uns nun bekannt:
        </div>
        <div>
          <ul>
            <li><NodeLegend type="susceptible"/> &nbsp;<b>Susceptible</b></li>
            <li><NodeLegend type="infected"/> &nbsp;<b>Infected</b></li>
            <li><NodeLegend type="removed"/> &nbsp;<b>Recovered</b></li>
          </ul>
        </div>
        <div>
        <iframe src="https://infolab.cs.uni-saarland.de/wp-admin/admin-ajax.php?action=h5p_embed&id=6" width="936" height="309" frameborder="0" allowfullscreen="allowfullscreen"></iframe><script src="https://infolab.cs.uni-saarland.de/wp-content/plugins/h5p/h5p-php-library/js/h5p-resizer.js" charset="UTF-8"></script>
        </div>
        <div>
          Bei vielen Viren führt eine einmalige Infektion zu einer Resistenz nach der Genesung. Auch bei SARS-CoV-2 wird dies erhofft und auch weitestgehend angenommen. Das Verhalten gelte nun auch für das Beispielvirus in den Simulationen.
        </div>
        <div>
          Unglücklicherweise entwickelt nicht jeder Erkrankte sofort Symptome, sondern ist bereits einige Tage vorher infektiös gegenüber der susceptible-Gruppe. So auch beispielsweise im Falle von Covid-19. Die Simulationen werden daher um einen Parameter ergänzt:
        </div>
        <div>
          <h3>Inkubations-Zeit</h3>
        </div>
        <div>
          Als Inkubationszeit wird die Zeitperiode zwischen der Infektion mit einer Krankheit und des Ausbruchs der ersten Symptome beschrieben. Diese Zeit ist besonders riskant, da Erkrankte zu diesem Zeitpunkt nicht wissen, dass sie infektiös sind und mit sehr hoher Wahrscheinlichkeit - wenn auch unbeabsichtigt - weitere Menschen anstecken können. Beispielhaft könnte dieses Verhalten so aussehen:
        </div>
        <Figure>
          <Grid gridRows={25}
                gridCols={25}
                nodeSize={20}
                nug={1}
                randomSeed={100}
                personHours={4}
                showDaysPerStateControls={true}
                showInteractions={false}
                speed={0.4}
                transmissionProbability={1}
                travelRadius={1}
          />
        </Figure>
        <div>
          Es sei an dieser Stelle festgehalten, dass sich Infizierte im Modell gleich verhalten, egal ob sie als Teil der infected-Gruppe bereits Symptome zeigen oder aber infiziert sind ohne Symptome zu zeigen. Letztere Gruppe wird auch als <strong>exposed</strong> bezeichnet. 
        </div>
        <div>
          Die Liste der Gruppen lässt sich nun also ergänzen:
        </div>
        <div>
          <ul>
            <li><NodeLegend type="susceptible"/> &nbsp;<b>Susceptible</b></li>
            <li><NodeLegend type="exposed"/> &nbsp;<b>Exposed (Inkubationszeit, keine Symptome)</b></li>
            <li><NodeLegend type="infected"/> &nbsp;<b>Infected (Mit Symptomen)</b></li>
            <li><NodeLegend type="removed"/> &nbsp;<b>Recovered</b></li>
          </ul>
        </div>
        <div>
        <iframe src="https://infolab.cs.uni-saarland.de/wp-admin/admin-ajax.php?action=h5p_embed&id=7" width="936" height="354" frameborder="0" allowfullscreen="allowfullscreen"></iframe><script src="https://infolab.cs.uni-saarland.de/wp-content/plugins/h5p/h5p-php-library/js/h5p-resizer.js" charset="UTF-8"></script>
        </div>
        <div>
          <h3>Wie wahrscheinlich ist eine Infektion?</h3>
        </div>
        <div>
          An dieser Stelle dürfte dem aufmerksamen Leser bereits aufgefallen sein, dass die Simulationen einen sehr strikten Ansatz zur Infektion weiterer Menschen wählt: Hat jemand aus der Gruppe der susceptible Kontakt zu einem Infizierten, so wird er <strong>mit Sicherheit</strong> ebenfalls infiziert. 
        </div>
        <div>
          Selbst für eine hochansteckende Krankheit, ein Virus, das sich sehr schnell ausbreitet, ist diese Annahme allerdings deutlich überdimensioniert. Vielmehr hat jeder Erreger eine gewisse Wahrscheinlichkeit, die sogenannte <strong>Übertragungsrate</strong>, auf einen weiteren Menschen überzugehen und diesen zu infizieren. Mithilfe des Schiebereglers unter der Grafik kann diese nun kontrolliert werden.
        </div>
        <Figure>
          <Grid gridRows={51}
                gridCols={51}
                maxTransmissionRate={1}
                nodeSize={10}
                nug={5}
                randomSeed={99}
                personHours={4}
                showDaysPerStateControls={true}
                showInteractions={false}
                showProTip={true}
                showTransmissionProbabilitySlider={true}
                speed={0.9}
                transmissionProbability={0.5}
                travelRadius={1}
          />
        </Figure>
        <div>
        <iframe src="https://infolab.cs.uni-saarland.de/wp-admin/admin-ajax.php?action=h5p_embed&id=9" width="958" height="255" frameborder="0" allowfullscreen="allowfullscreen"></iframe><script src="https://infolab.cs.uni-saarland.de/wp-content/plugins/h5p/h5p-php-library/js/h5p-resizer.js" charset="UTF-8"></script>
        </div>
        <div style={{marginLeft: '2em'}}>
          {showSpoilerButton}
        </div>
        <div>
          In den meisten Fällen sollte die Übertragungsrate zwischen <span className={spoilerOrNot}>0.35</span> und <span className={spoilerOrNot}>0.34</span> liegen. Die Werte darunter führen im Regelfall nicht zu einer Infektion der Bevölkerung, darüber werden alle Quadrate nach einiger Zeit rot eingefärbt sein.
        </div>
        <div>
          Neben der Infektionsrate ist auch die sogenannte <strong>Basisreproduktionszahl</strong> von großer Bedeutung bei der Untersuchung von Epidemien. Sie beschreibt, wie viele Menschen von einem einzelnen Infizierten ebenfalls infiziert werden, sofern keine eindämmenden Maßnahmen getroffen werden. Somit kann abgeleitet werden, wie viele Menschen zu Beginn eines Ausbruchs einer Krankheit bzw. eines Virus immun gegen den Erreger sein müssten, um die Epidemie zu verhindern. Aus der Basisreproduktionszahl leitet sich weiter die <strong>effektive Nettoreproduktionszahl</strong> sowie die <strong>Nettoreproduktionszahl zu einem Zeitpunkt <em>t</em> </strong>ab. Diese beschreiben, wie viele Menschen im Durchschnitt durch einen Infizierten angesteckt werden unter Berücksichtigung von eindämmenden Maßnahmen (im ersten Fall im Durchschnitt, im zweiten Fall zu einem bestimmten Zeitpunkt der Epidemie). Im Fall des SARS-CoV-2 Virus wird eine Basisreproduktionszahl zwischen 1.4 und 5.7 vermutet, das heißt auf jeden Infizierten kommen 1 bis 6 neue Infizierte. Jedoch konnten noch keine eindeutigen Ergebnisse produziert werden und die Zahlen schwanken von Land zu Land aufgrund unterschiedlicher Maßnahmen. Zum Vergleich:
          <ul>
            <li>Malaria: länderspezifisch zwischen 1.4 (Indien) und 1900 (Kenia)</li>
            <li>Masern: 12-18</li>
            <li>Influenza: 0.9-2.1</li>
            <li>Spanische Grippe: 1.4-2.0</li>
          </ul>
        </div>
        <div>
          Mit diesen Bezeichnungen können wir nun auch die Schwere des Ausbruchs einer Epidemie genauer spezifizieren:
          <ul>
            <li>Endemischer Verlauf: Die Basisreproduktionszahl bleibt über den Verlauf des Ausbruchs in Relation zur Anzahl der <em>Susceptible</em> ungefähr gleich  </li>
            <li>Epidemischer Verlauf: Oben genannte Kombination der beiden Faktoren wird im Verlauf des Ausbruchs größer. Erstreckt sich eine Epidemie über einen besonders langen Zeitraum sowie mehrere Länder und Kontinente spricht man auch von einer Pandemie.</li>
          </ul>
        </div>
        <div>
          <h3>Ein Exkurs in die Erzeugung von Zufallszahlen</h3>
        </div>
        <div>
          Man beachte: Wir arbeiten in unseren Simulationen mit einem stochastischen Modell, das heißt es gibt eine gewisse Wahrscheinlichkeit, dass eine Übertragung stattfindet. Daher wird jeder Ausbruch der Krankheit - also jede erneute Simulation des gleichen Szenarios - anders verlaufen und es können in seltenen Fällen auch unerwartete Ergebnisse auftreten. Es liegt im Rahmen des Möglichen, obgleich dies sehr unwahrscheinlich ist, dass bei einer Übertragungsrate von 99% nur eine einzige Person erkrankt. Zur Versinnbildlichung: Man werfe einen Würfel 6 mal. Natürlich ist es möglich aber unwahrscheinlich, dass jedes mal die Augenzahl 3 fällt (um genau zu sein liegt die Wahrscheinlichkeit bei rund 0.002%). Man stelle sich jetzt vor der Würfel hätte 100 Seiten, von denen 99 Seiten mit "i" beschriftet sind - das heißt eine Infektion findet statt - und eine einzelne Seite mit "k", keine Infektion. Bei jedem Simulationsschritt wird nun dieser Würfel für jeden Menschen, der Kontakt zu einem Infizierten hat(te), geworfen.
        </div>
        <div>
          Beantworten Sie die folgenden Fragen mit <em>richtig</em> oder <em>falsch</em>.
        </div>
        <div>
        <iframe src="https://infolab.cs.uni-saarland.de/wp-admin/admin-ajax.php?action=h5p_embed&id=10" width="958" height="211" frameborder="0" allowfullscreen="allowfullscreen"></iframe><script src="https://infolab.cs.uni-saarland.de/wp-content/plugins/h5p/h5p-php-library/js/h5p-resizer.js" charset="UTF-8"></script>
        </div>
        <div>
          Aber wie kann der Rechner eigentlich etwas <strong>Zufälliges</strong> erzeugen? 
        </div>
        <div>
          Die rigorose Antwort ist: <strong>gar nicht</strong>! Allerdings können Zahlenketten erzeugt werden, die dem echten Zufall sehr sehr ähnlich sind. Man spricht auch von sogenanntem Pseudo-Zufall. In diesem Modell wird ein sogenannter <strong>linearer Kongruenzgenerator</strong> genutzt. Besagte Technik erzeugt zwar in vielen Fällen nicht die bestmögliche Annäherung an den echten Zufall, jedoch ist sie sehr einfach zu programmieren. Ein linearer Kongruenzgenerator benötigt zunächst einen Startwert <em>z</em>. Mithilfe eines Faktors <em>a</em>, eines sogenannten <strong>Inkrements</strong> <em>b</em> und des <strong>Moduls</strong> <em>m</em> wird daraus der nächste Wert über die Formel <em>z_neu = (a*z + b) mod m</em> berechnet. Die Rechenoperation <em>mod</em> gibt dabei den Rest der Division durch m zurück. Mit dem neuen Wert wird nun die gleiche Formel wieder und wieder angewandt. Je nach Wahl der einzelnen Größen <em>a, b, m</em> werden so scheinbar zufällige Zahlen erzeugt. Näher soll an dieser Stelle nicht darauf eingegangen werden, dem interessierten Leser sei das verlinkte Video zu Zufallszahlen empfohlen (Video folgt in Kürze ...)
        </div>
        <div>
          Natürlich ist unser Modell an dieser Stelle wieder einmal stark vereinfacht. Unsere Quadrate haben entweder Kontakt in ihrer kleinen quadratischen Welt (nämlich zu genau ihren 4 direkten Nachbarn) oder haben <strong>keinen</strong> Kontakt. Die echte Welt ist allerdings nicht "binär", sondern es gibt verschiedene Arten der Interaktion, die unterschiedliche Wahscheinlichkeiten zur Übertragung hervorbringen. Es ist selbstverständlich ein Unterschied, ob sich zwei Geschäftsleute bei einem Meeting die Hand schütteln, zwei Sportler der Bequemlichkeit halber aus der gleichen Flasche trinken oder ob sich zwei gute Freunde zur Begrüßung umarmen oder küssen. Genauso spielt in einem komplexen (richtigen? ... richtigeren?!) Modell die Umwelt eine große Rolle. Im Zusammenhang mit COVID-19 und dem entsprechenden sich ausbreitenden Coronavirus, hoffen Forscher auf die Temperatur- und Feuchtigkeitsänderungen im Sommer und damit zusammenhängend eine Reduktion der ohnehin schon vielen Grippe-Patienten. Auch Hygiene, alias Hände waschen, Mundschutz tragen, etc. hat einen extremen Einfluss auf die Verbreitung von Viren. All das könnte mit entsprechendem Aufwand modelliert werden. 
        </div>
        <div>
          <strong>Diesen Anspruch erhebt das Modell aber nicht</strong>. Wie eingangs erwähnt, geht es lediglich um allgemeine Modellierungsschritte, die dazu beitragen sollen, das Allgemeinverständnis der Ausbreitung von Epidemien zu stärken und aufgrund derer komplexere Modelle geschaffen werden können, die beispielsweise mehrere verschiedene Arten der Interaktion berücksichtigen. 
        </div>
        <div>
          Des Weiteren kann für jeden Ausbruch eines Virus mittels einschränkender Maßnahmen eine Übertragungsrate gefunden werden, so infektiös der Virus auch sein mag, sodass eine Ausbreitung nicht mehr möglich ist. Im Fall von SARS-CoV-2 ist dieses Virus allerdings so infektiös, dass die <strong>kritische Schranke</strong> ("critical threshold") allerdings so niedrig, dass es schon extremster Maßnahmen bedürfe, um die Infektionskette zu <strong>stoppen</strong>. Die folgenden Maßnahmen sollen zeigen, wie die Infektionswelle <strong>verlangsamt</strong> werden kann, um - wie Sie später noch sehen werden - das Gesundheitssystem nicht zu überlasten und die Behandlungsmöglichkeiten für Erkrankte zu maximieren. 
        </div>
        <div>
          <h3>Reisen</h3>
        </div>
        <div>
          Bisher sind alle Menschen im Modell an ihrem Platz geblieben und hatten nur Kontakt zu ihren 4 direkten Nachbarn. Diese Annahme soll nun verworfen werden: Die Quadrate dürfen verreisen!
        </div>
        <div>
          Dazu wird ein neuer Parameter eingeführt, der Reise-Radius. Innerhalb dieser Entfernung dürfen Menschen an einen anderen Ort verreisen - und können dort Personen infizieren, zu denen vorher kein Kontakt bestand. Im Modell erhält jede Person mehrfach am Tag die Möglichkeit an einen zufälligen Ort innerhalb ihres Reise-Radius zu reisen.
        </div>
        <div>
          Wird der Reise-Radius stark beschränkt, z.B. dadurch, dass es keine Flughäfen gibt, keine Fernbusse und keine Autos, so kann die Verbreitung des Virus sehr schnell um einen großen Faktor verlangsamt werden. Zum einen Gott sei Dank, zum Anderen leider sieht die Realität anders aus. Was passiert, wenn der Radius zum Reisen zu Anfang auf einem normalen Level liegt, man nehme an, 25 ist ein regulärer Wert, und erst nach einigen Tagen nach Beginn der Infektionskette wird dieser nach und nach verkleinert, zunächst auf 15 (keine Flüge mehr ins Ausland) und später auf 5 (keine Inlandsreisen mehr)?
        </div>
        <div>
          Hier einige weitere Beispiele zum selbst testen (Startwert jeweils 25):
          <ul>
            <li>Keine Maßnahmen</li>
            <li>Restriktionen unmittelbar nach dem ersten beobachteten Fall</li>
            <li>Restriktionen 10 Tage nach dem ersten beobachteten Fall</li>
            <li>Restriktionen unmittelbar nach dem ersten beobachteten Fall, Lockerung der Maßnahmen nach einigen Wochen</li>
          </ul>
        </div>
        <Figure>
          <Grid degree={24}
                gridRows={51}
                gridCols={51}
                maxTransmissionRate={1}
                nodeSize={10}
                nug={5}
                personHours={4}
                randomSeed={99}
                showAliveFraction={true}
                showInteractions={true}
                // showTransmissionProbabilitySlider={true}
                showTravelRadiusSlider={true}
                speed={0.8}
                travelRadius={15}
          />
        </Figure>
        <div>
          Der Graph unterhalb der Simulation zeigt, welcher Anteil der Bevölkerung infiziert, gefährdet und nicht mehr infiziert ist. Im Zusammenhang mit dem aktuellen Coronavirus sprechen Medien immer wieder vom <strong>Abflachen der Kurve</strong> und <strong>exponentiellem Wachstum</strong>. Genau diese Effekte können in dieser Darstellung beobachtet werden. Werden Maßnahmen zur Einschränkung des Reiseverkehrs erst spät oder garnicht eingeleitet, so kann sich das Virus extrem schnell ausbreiten: Die rote Kurve steigt sehr schnell an, man nennt diese Art von Wachstum "exponentiell" oder auch "logistisch". 
        </div>
        <div>
          Was bedeutet das für die Bevölkerung und das Gesundheitssystem? Auf einen Schlag gibt es sehr viele Patienten, von denen einige unter Umständen stationär behandelt werden müssen. Ist die "Spitze" der Kurve zu hoch, gibt es also zu viele Patienten auf einmal, so kann es passieren, dass einige von ihnen nicht behandelt werden können. 
        </div>
        <div> Wie wirken sich nun frühzeitige Maßnahmen aus? Man kann beobachten, dass die rote Kurve zwar immer noch recht steil nach oben geht, der höchste Punkt allerdings bei Weitem nicht so hoch liegt, wie es noch im vorherigen Szenario der Fall gewesen ist. Dieser Effekt ist mit dem "Abflachen der Kurve" gemeint. Auf diese Art gibt es nicht so viele Patienten auf einmal (obgleich die Gesamtanzahl der irgendwann Erkrankten gleich bleibt) und Krankenhäuser, Ärzte und Apotheken können die Erkrankten besser behandeln. 
        </div>
        <div>
          Heißt das, in unserer momentanen Situation ist/war es sowieso schon zu spät? Alle Maßnahmen haben keinen Sinn mehr? <strong>Nein!</strong>:
          <ol>
            <li>In Flugzeugen, Bussen, Zügen oder auf Schiffen sitzen viele Menschen auf einem Fleck. Gefundenes Fressen für einen aggressiven Virus ... Wir modellieren hier lediglich die Auswirkungen, die die Reise in ein bestimmtes Gebiet hat, nicht die Auswirkungen während der Reise.</li>
            <li>Möglicherweise war es für eine bestimmte Region "zu spät", Maßnahmen zu ergreifen, andere Regionen stehen aber womöglich noch am Anfang der Epidemie (man denke an den Vergleich zwischen China und Deutschland vor einigen Wochen). An dieser Stelle gilt es, die noch nicht betroffenen Gebiete zu schützen.</li>
          </ol>
        </div>
        <div>
          <h3>
            Ein kleiner Test zur Überprüfung des Gelernten:
          </h3>
          <iframe src="https://infolab.cs.uni-saarland.de/wp-admin/admin-ajax.php?action=h5p_embed&id=2" width="936" height="176" frameborder="0" allowfullscreen="allowfullscreen"></iframe><script src="https://infolab.cs.uni-saarland.de/wp-content/plugins/h5p/h5p-php-library/js/h5p-resizer.js" charset="UTF-8"></script>
        </div>
        <div>
          <h3>Wie viele Kontakte haben die Menschen am Tag?</h3>
        </div>
        <div>
          Eine weitere Annahme, die einen kritischen Einfluss auf den Verlauf einer Epidemie hat, betrifft die Anzahl der Kontakte, die zwei Personen in der Bevölkerung haben. Bisher wurde von einer Anzahl von 20 Kontakten pro Tag ausgegangen. Wie wir alle wissen, wurden diese Kontakte drastisch eingeschränkt. Welche Folgen hat dies? 
        </div>
        <div>
          Die Anzahl der Kontakte kann nun in der Simulation eingestellt werden. Untersuchen Sie den Einfluss, den eine Reduktion der Kontakte hat. Vergleichen Sie dabei auch mit dem Einfluss des Reisens (wir vernachlässigen hier Flughafenpersonal). Hat eine Reduktion der Kontakte um 50% den gleichen Effekt wie eine Reduktion des Reisens um den gleichen Faktor?
        </div>
        <Figure>
          <Grid degree={24}
                gridRows={51}
                gridCols={51}
                personHours={20}
                nodeSize={10}
                nug={5}
                randomSeed={100}
                showAliveFraction={true}
                showInteractions={true}
                showPersonHoursSlider={true}
                showTransmissionProbabilitySlider={true}
                showTravelRadiusSlider={true}
                speed={0.8}
                transmissionProbability={0.3}
                travelRadius={10}
          />
        </Figure>
        <div>
          Wie man beobachten kann, ist der Einfluss der sogenannten <strong>sozialen Distanz</strong> enorm. Erreicht der Wert eine gewisse Schwelle (Test: Wo liegt diese Schwelle bei einem Reise-Radius von 10?), so ist es sogar möglich, die Ausbreitung der Epidemie komplett zu stoppen. Das ist unter Anderem ein Grund, warum Schulschließungen, Home Office und Ausgangsbeschränkungen aufgrund der Ausbreitung von COVID-19 unabdingbar waren, wie die Simulation zeigt. Man könnte soweit gehen und behaupten, es sei die <strong>einzige Möglichkeit</strong>, die Ausbreitung der Krankheit deutlich spürbar einzuschränken. Mit dieser Behauptung sollten sich allerdings Experten beschäftigen, lassen Sie uns daher zurück zur Simulation kommen.
        </div>
        <div>
          <h3>Tod von Patienten</h3>
        </div>
        <div>
          Leider erholt sich längst nicht jeder Patient von einer Infektion mit einem Virus. Auch im Zuge der Corona-Krise mussten bereits zu diesem Zeitpunkt viele Tote beklagt werden. Schätzungsweise sterben an COVID-19 zwischen 1 und 6% der Infizierten, besonders ältere Menschen und Personen mit Vorerkrankungen sind betroffen. Diese Zahl wird <strong>Tödlichkeit</strong> genannt und fließt nun in unser Modell ein. Sie beschreibt die Wahrscheinlichkeit, dass eine Person aus der Gruppe der Infizierten die Erkrankung nicht überlebt. Neben roten und grauen Punkten, gibt es nun auch schwarze Quadrate, die die Opfer der Krankheit symbolisieren. 
        </div>
        <div>
          Lassen Sie die Simulation mit verschiedenen Parameterkombinationen laufen. Bedenken Sie an dieser Stelle: Jeder schwarze Punkt bedeutet ein Menschenleben, das von der Epidemie eingefordert wurde.
        </div>
        <Figure>
          <Grid gridRows={101}
                gridCols={101}
                nodeSize={5}
                nug={5}
                randomSeed={100}
                showAliveFraction={true}
                showDeaths={true}
                showDeathRateSlider={true}
                showPersonHoursSlider={true}
                showTransmissionProbabilitySlider={true}
                showTravelRadiusSlider={true}
                speed={1}
                transmissionProbability={0.3}
          />
        </Figure>
        <div>
          Glücklicherweise kann die Zahl der Opfer durch eine geeignete Behandlung im Krankenhaus mit moderner Medizintechnik eingedämmt werden. Wie schon eingangs erwähnt sind die Betten (besonders auf den Intensivstationen) allerdings beschränkt. Wir erweitern unser Modell um diesen Parameter:
        </div>
        <div>
          <h3>Krankenhauskapazität</h3>
        </div>
        <div>
        Untenstehend führen wir einen letzten zusätzlichen Schieberegler ein, der die <strong>Krankenhauskapazität</strong> regeln kann. Mit diesem Regler kann eingestellt werden, wie viele Prozent der Bevölkerung <strong>gleichzeitig</strong> vom Gesundheitssystem getragen werden können. Dieser Faktor ist äußerst wichtig, denn sind zu viele Personen erkrankt und behandlungsbedürftig, könnte es passieren, dass nicht genug Personal, Betten, medizinisches Equipment etc. vorhanden ist, um diese Menschen zu behandeln und wesentlich mehr Menschen sterben würden. In unserem Modell kümmern wir uns zunächst nicht darum, <strong>wodurch</strong> die Kapazitäten beschränkt sind, es ist uns nur wichtig einen Faktor zu haben, der diese Beschränkung in einem allgemeinen Sinn modellieren kann. Tatsächlich ist das Modell an dieser Stelle sehr allgemein, sodass eine Übersteigung der Krankenhauskapazität eine Verdopplung der Mortalität nach sich zieht. Nachstehend erneut eine Simulation die nun auch die Krankenhauskapazität variabel einstellen lässt.
        </div>
        <Figure>
          <Grid gridRows={101}
                gridCols={101}
                hospitalCapacityPct={0.05}
                nodeSize={5}
                nug={5}
                personHours={15}
                randomSeed={100}
                showAliveFraction={true}
                showDeaths={true}
                showDeathRateSlider={true}
                showHospitalCapacitySlider={true}
                // showPersonHoursSlider={true}
                // showTransmissionProbabilitySlider={true}
                // showTravelRadiusSlider={true}
                speed={1}
                transmissionProbability={0.28}
                travelRadius={15}
          />
        </Figure>
        <div>
          <h3>"Flatten the curve"</h3>
        </div>
        <div>
          In der letzten Simulation können Sie nun nach Belieben mit den im Laufe dieser Vorstellung eingeführten Variablen experimentieren und selbst Erkenntnisse darüber sammeln, wie wichtig viele der Maßnahmen sind. Behalten Sie dabei auch die Situation in Zusammenhang mit <strong>dem</strong> Coronavirus im Hinterkopf, bedenken Sie jedoch auch, dass unser Modell keinen Anspruch auf die korrekte Modellierung explizit dieser Pandemie erhebt. 
        </div>
        <Figure>
          <Grid gridRows={101}
                gridCols={101}
                hospitalCapacityPct={0.05}
                nodeSize={5}
                nug={5}
                personHours={15}
                randomSeed={100}
                showAliveFraction={true}
                showDeaths={true}
                showDeathRateSlider={true}
                showHospitalCapacitySlider={true}
                showPersonHoursSlider={true}
                showTransmissionProbabilitySlider={true}
                showTravelRadiusSlider={true}
                speed={1}
                transmissionProbability={0.4}
                travelRadius={15}
          />
        </Figure>





        <div>
          &nbsp;
        </div>
        <div>
          &nbsp;
        </div>
        <div>
          ——
        </div>
        <div>
          &nbsp;
        </div>
        <div>
          <b>License</b>
        </div>
        <div>
          <a href="https://creativecommons.org/share-your-work/public-domain/cc0/">CC0</a> — no rights reserved. You're free to use this work however you see fit, including copying it, modifying it, and distributing it on your own site.
        </div>
        <div>
          <a href="https://github.com/kevinsimler/outbreak">Original source code by Kevin Simler</a>
        </div>
        
        <div>
          &nbsp;
        </div>
        <div>
          <h3>Komplettes Modell</h3>
        </div>
        <Figure>
          <Grid gridRows={101}
                gridCols={101}
                highlight="transmissionRate"
                hospitalCapacityPct={0.05}
                nodeSize={5}
                nug={5}
                randomSeed={100}
                showAliveFraction={true}
                showAllControls={true}
                // showDaysPerStateControls={true}
                showDeaths={true}
                showTransmissionProbabilitySlider={true}
                showChanceOfIsolationAfterSymptomsSlider={true}
                showPersonHoursSlider={true}
                showTransmissionProbabilitySlider={true}
                showTravelRadiusSlider={true}
                speed={1}
          />
        </Figure>

      </div>
    );
  }

  renderSubscribeForm() {
    return (
      <form method="post" action="https://meltingasphalt.us8.list-manage.com/subscribe/post?u=0bc9d741e167733d20c520ea6&amp;id=57ebd9b4a6" id="mc4wp-form-1" className="form mc4wp-form"><input type="email" id="mc4wp_email" name="EMAIL" placeholder="Enter your email" required />
        <input type="submit" value="Subscribe" />
        <textarea name="_mc4wp_required_but_not_really" style={{display: "none"}}/><input type="hidden" name="_mc4wp_form_submit" value="1" /><input type="hidden" name="_mc4wp_form_instance" value="1" /><input type="hidden" name="_mc4wp_form_nonce" value="8a45344b67" />
      </form>
    )
  }

  renderEndOfPostDivider(showTimestamp: boolean) {
    let timestamp = "";
    let divider = <span>——</span>;
    if (showTimestamp) {
      timestamp = "Originally published March 16, 2020.";
      divider = <img src="https://meltingasphalt.com/wp-content/themes/responsive/core/images/flourish.svg" width={100} alt="——" />;
    }

    return (
      <div style={{textAlign: "center"}}>
        <div className="end-of-post-divider">
          {divider}
        </div>
        <div className="signature-line">
          {timestamp}
        </div>
      </div>
    );
  }

  renderHeader() {
    return (
        <div id="header">
          <div id="logo" className="branded">
            <span className="site-name">
              <a href="https://infolab.cs.uni-saarland.de" title="InfoLab Saar" rel="home">
                <img id="nav-logo" src="https://infolab.cs.uni-saarland.de/wp-content/uploads/2019/05/InfoLabSaar-Headerbild-1.png"/>
                                        &nbsp;&nbsp;InfoLab Saar
              </a>
            </span>
          </div>
        </div>
    );
  }

  render() {
    return (
      <div className="main-container">
        <div className="header">
          {this.renderHeader()}
        </div>
        <div className="blank-l"/>
        <div className="content">
          {this.renderMainPost()}
        </div>
        <div className="blank-r"/>
        <div className="footer"/>
      </div>
    );
  }
}

export default App
